import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import CustomModal from '../../molecules/Modal';

const { TextArea } = Input;

function ModalRequestReopening({ open, onCancelClick, onConfirmClick }) {
  const [justification, setJustification] = useState('');

  return (
    <CustomModal
      title="Solicitar Alteração do Período"
      okText="Solicitar"
      cancelText="Cancelar"
      onCancel={onCancelClick}
      okButtonProps={{ disabled: !justification }}
      onOk={() => onConfirmClick(justification)}
      open={open}
      afterClose={() => setJustification('')}
    >
      <Label label="Justifique o motivo da alteração*">
        <TextArea
          placeholder="Insira aqui uma sugestão de novo período de lançamento e uma observação justificando a solicitação"
          rows={6}
          value={justification}
          maxLength={1000}
          type="text"
          onChange={(e) => setJustification(e.target.value)}
        />
      </Label>
    </CustomModal>
  );
}

ModalRequestReopening.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

export default ModalRequestReopening;
